<template>
  <svg width="121" height="120" viewBox="0 0 121 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_28_15800"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="121"
      height="120"
    >
      <path d="M120.5 0H0.5V120H120.5V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_28_15800)">
      <path
        d="M62.2735 0L44.2502 34.8451M44.2502 34.8451L5.5 59.6272M44.2502 34.8451L22.472 14.8692M44.2502 34.8451L62.2735 49.6672M105.98 85.6108L75.1151 60.228M75.1151 60.228L112.993 14.8692M75.1151 60.228L62.2735 49.6672M99.3386 6.10096L62.2735 49.6672M62.2735 49.6672L42.3727 73.3464M22.472 97.0256L42.3727 73.3464M42.3727 73.3464L81.6486 107.005M92.6128 116.401L81.6486 107.005M81.6486 107.005L70.6844 119.405"
        stroke="#1B365D"
        class="stroke-primary-800"
        stroke-opacity="0.25"
        stroke-width="3.25"
        stroke-linecap="round"
      />
      <g opacity="0.3">
        <path
          d="M63.0244 112.141C91.9056 112.141 115.318 88.7286 115.318 59.8475C115.318 30.9663 91.9056 7.55347 63.0244 7.55347C34.1432 7.55347 10.7304 30.9663 10.7304 59.8475C10.7304 88.7286 34.1432 112.141 63.0244 112.141Z"
          fill="#1B365D"
          class="fill-primary-800"
          fill-opacity="0.5"
        />
        <path
          d="M114.818 59.8475C114.818 88.4525 91.6294 111.641 63.0244 111.641C34.4194 111.641 11.2304 88.4525 11.2304 59.8475C11.2304 31.2424 34.4194 8.05347 63.0244 8.05347C91.6294 8.05347 114.818 31.2424 114.818 59.8475Z"
          stroke="#1B365D"
          stroke-opacity="0.25"
        />
      </g>
      <g opacity="0.6">
        <path
          d="M63.0246 100.521C85.4877 100.521 103.698 82.3106 103.698 59.8474C103.698 37.3843 85.4877 19.1743 63.0246 19.1743C40.5615 19.1743 22.3515 37.3843 22.3515 59.8474C22.3515 82.3106 40.5615 100.521 63.0246 100.521Z"
          fill="#7089AC"
          class="fill-primary-400"
        />
        <path
          d="M103.198 59.8474C103.198 82.0344 85.2116 100.021 63.0246 100.021C40.8376 100.021 22.8515 82.0344 22.8515 59.8474C22.8515 37.6604 40.8376 19.6743 63.0246 19.6743C85.2116 19.6743 103.198 37.6604 103.198 59.8474Z"
          stroke="#1B365D"
          class="stroke-primary-800"
          stroke-opacity="0.25"
        />
      </g>
      <path
        d="M63.025 83.0891C75.8611 83.0891 86.2668 72.6834 86.2668 59.8473C86.2668 47.0112 75.8611 36.6055 63.025 36.6055C50.1889 36.6055 39.7832 47.0112 39.7832 59.8473C39.7832 72.6834 50.1889 83.0891 63.025 83.0891Z"
        fill="#1B365D"
        class="fill-primary-800"
      />
      <path
        d="M85.7668 59.8473C85.7668 72.4072 75.585 82.5891 63.025 82.5891C50.4651 82.5891 40.2832 72.4072 40.2832 59.8473C40.2832 47.2873 50.4651 37.1055 63.025 37.1055C75.585 37.1055 85.7668 47.2873 85.7668 59.8473Z"
        stroke="#1B365D"
        class="stroke-primary-800"
        stroke-opacity="0.25"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M54.8896 56.669C54.8896 52.1718 58.527 48.5344 63.0243 48.5344C67.5215 48.5344 71.1589 52.1718 71.1589 56.669C71.1589 61.5149 66.0225 68.197 63.9191 70.7419C63.4542 71.2997 62.6059 71.2997 62.1411 70.7419C60.0261 68.197 54.8896 61.5149 54.8896 56.669ZM60.1178 56.6689C60.1178 58.2726 61.4194 59.5741 63.023 59.5741C64.6267 59.5741 65.9283 58.2726 65.9283 56.6689C65.9283 55.0652 64.6267 53.7637 63.023 53.7637C61.4194 53.7637 60.1178 55.0652 60.1178 56.6689Z"
        fill="white"
      />
      <path
        d="M55.3896 56.669C55.3896 52.448 58.8031 49.0344 63.0243 49.0344C67.2453 49.0344 70.6589 52.448 70.6589 56.669C70.6589 58.9472 69.4389 61.7286 67.8983 64.3123C66.3703 66.8747 64.5789 69.1587 63.5345 70.4224C63.2695 70.7396 62.7904 70.7395 62.5256 70.4223C61.4761 69.1595 59.6813 66.8751 58.1516 64.3121C56.6095 61.7286 55.3896 58.9471 55.3896 56.669ZM59.6178 56.6689C59.6178 58.5488 61.1433 60.0741 63.023 60.0741C64.9028 60.0741 66.4283 58.5488 66.4283 56.6689C66.4283 54.7891 64.9028 53.2637 63.023 53.2637C61.1433 53.2637 59.6178 54.7891 59.6178 56.6689Z"
        stroke="#1B365D"
        class="stroke-primary-800"
        stroke-opacity="0.25"
      />
    </g>
  </svg>
</template>
